<template>
  <div class="ai-customer-service">
    <div class="module-item-style">
      <div class="module-item-title robot-title-with-switch">
        <div>是否开启AI客服</div>
        <div class="advanced-robot-switch-btn">
          <el-switch v-model="aiRobotSwitch" @click.native="saveChange('is_open_ai_robot', aiRobotSwitch)"
            active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="advanced-robot-tips">
        开启后，所有客服都将成为AI客服，您也可以给客服单独设置AI托管方案，客服自己也可以在客服端设置自己的托管方案。<br>
        AI客服与智能机器人不同，AI客服是基于大模型的智能体，而智能机器人只会简单地搜索知识库。
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ai-customer-service',
  data() {
    return {
      aiRobotSwitch: false,
    }
  },
  created() {

  },
  mounted() {
    this.initRobotConfig()
  },
  methods: {
    initRobotConfig() {
      this.$http.getRobotConfigAPI().then(res => {
        if (res.status == 1) {
          let robotInfo = res.data
          // AI 智能客服开关初始化
          if (robotInfo.is_open_ai_robot == 1) {
            this.aiRobotSwitch = true
          } else if (robotInfo.is_open_ai_robot == 0) {
            this.aiRobotSwitch = false
          }
        }
      })
    },
    saveChange(name, value) {
      let postVal
      if (name == 'is_open_robot' || name == 'is_auto_robot_time' || name == 'is_open_input_auto_redirect' || name == 'is_open_ai_robot') {
        if (value) {
          postVal = 1
        } else {
          postVal = 0
        }
      } else {
        postVal = value
      }


      this.$http.robotConfigSettingAPI({
        name,
        value: postVal,
      }).then(res => {
        if (res.status == 1) {
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.initRobotConfig()
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
  }
}
</script>

<style lang="scss">
.ai-customer-service {
  .input-width {
    width: 600px;

    &.zIndex9 {
      .w-e-toolbar .w-e-menu {
        z-index: 999 !important;
      }
    }
  }

  .w-e-text {
    padding: 10px;
  }

  .robotSwitchTimeBtn {
    margin-left: 20px;
  }

  .setting-advanced-robot-num-tips {
    border-radius: $mainBorderRadius;
    background-color: #fff2d7;
    border: 1px solid #ffdf9c;
    margin-bottom: 10px;
    line-height: 40px;
    font-size: 12px;
    color: #666;
    display: flex;
    padding: 0 19px;
    position: relative;

    .msg-leave-num {
      font-size: 14px;
      color: #ff4e00;
      font-weight: bold;
      padding: 0 5px;
    }

    .robot-num-close-btn {
      position: absolute;
      right: 0px;
      top: 50%;
      margin-top: -9px;
      cursor: pointer;
    }
  }

  .advanced-robot-tips {
    color: #999;
    font-size: 12px;
    padding: 12px 0 15px 0;
    line-height: 20px;
  }

  .robot-title-with-switch {
    display: flex;

    .advanced-robot-switch-btn {
      margin-left: auto;
    }
  }

  .advanced-content-container {
    font-size: 12px;
    color: #666;

    .can-edit-div-box {
      width: 600px;
      height: 100px;
      border-radius: $mainBorderRadius;
      border: solid 1px #e4e7ed;
      padding: 8px;

      .can-edit-div {
        width: 100%;
        height: 100%;
        outline: none;
        overflow-y: scroll;

        &:empty:before {
          content: attr(data-placeholder);
          color: #bbb;
        }

        &:focus:before {
          content: none;
        }
      }
    }

    .robot-model-container {
      .model-item {
        display: block;
        line-height: 30px;
        color: #333;

        .el-radio__label {
          font-size: 12px;
        }

        white-space: inherit;

        .model-item-desc {
          color: #999;
          display: block;
          line-height: 1;
          padding-left: 23px;
        }
      }
    }

    .robot-setting-recognition {
      padding: 15px 0;

      .recognition-times {
        width: 75px;
        margin: 0 8px;
      }

      .type-change {
        margin: 0 8px;
        width: 80px;
      }
    }

    .small-title {
      color: #333;
      line-height: 40px;
    }
  }

  .link-to-knowledge {
    color: $mainColor;
    padding-left: 10px;
    cursor: pointer;
  }

  .robot-info-container {
    display: flex;
    align-items: center;

    .robot-avatar {
      width: 90px;
      height: 71px;
      padding-right: 22px;

      img {
        width: 68px;
        height: 68px;
        border-radius: 50%;
        overflow: hidden;
      }

    }
  }

  .robot-name {
    padding: 20px 0;
    display: flex;
    align-items: center;

    .robot-name-input {
      width: 200px;
    }

    .robot-name-label {
      padding-right: 12px;
      color: #333333;
    }
  }

  .add-redirect-wrap,
  .redirect-table {
    .el-input {
      width: 200px;
      margin-right: 20px;
    }
  }

  .redirect-table {
    .el-tag {
      margin-right: 25px;
      line-height: 40px;
      height: 40px;
      margin-bottom: 15px;
    }
  }

  .input-auto-redirect-content-wrap {
    .el-input {
      max-width: 400px;
      font-size: 12px;
    }

    .title-small {
      color: #333;
      line-height: 40px;
    }
  }
}
</style>
